<div class="row my-2">
    <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
        <p class="title mb-0">Estamos quase lá...</p>
    </div>
</div>

<div class="row my-2">
    <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
        <!-- <p class="subtitle">Preencha seu email e defina uma senha de acesso</p> -->
        <p class="subtitle">Defina uma senha de acesso</p>
    </div>
</div>

<div class="row my-3">
    <div class="col-lg-8 col-md-8 col-sm-12 m-auto">
        <form [formGroup]="gestorCadastroFormGroup" #gestorCadastroForm="ngForm"
            (ngSubmit)="onSubmit(gestorCadastroFormGroup.value)" autocomplete="new-password">
            <div class="py-2">
                <!-- <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 vl-right">
                        <div class="custom-pr-5">
                            <div class="input-container">
                                <input formControlName="email" id="email" class="input" type="email" autocomplete="new-password"/>
                                <label class="label" for="email">E-mail corporativo</label>
                            </div>
                            <div *ngIf="form.email.invalid && (form.email.dirty || form.email.touched)"
                                class="text-danger">
                                <div *ngIf="form.email.errors.required">
                                    E-mail é obrigatório
                                </div>
                                <div *ngIf="form.email.errors.email">
                                    Formato de e-mail inválido
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pl-5">
                            <div class="input-container">
                                <input formControlName="emailConfirmacao" id="emailConfirmacao" class="input"
                                    type="email" autocomplete="new-password"/>
                                <label class="label" for="emailConfirmacao">Confirmar e-mail coorporativo</label>
                            </div>
                            <div *ngIf="form.emailConfirmacao.invalid && (form.emailConfirmacao.dirty || form.emailConfirmacao.touched)"
                                class="text-danger">
                                <div *ngIf="form.emailConfirmacao.errors.required">
                                    E-mail é obrigatório
                                </div>
                                <div *ngIf="form.emailConfirmacao.errors.email">
                                    Formato de e-mail inválido
                                </div>
                                <div *ngIf="form.emailConfirmacao.errors.mustMatch">
                                    Os e-mails devem coincidir
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2 vl-right">
                        <div class="custom-pr-5">
                            <div class="input-container">
                                <label class="label" for="senha">Senha
                                <ngx-mat-popover
                                    [popoverContent]="popoverContent"
                                    [xPosition]="'after'"
                                    [yPosition]="'above'"
                                    #popover>
                                    <i class="fas fa-info-circle pl-2" style="color: white; cursor: pointer;"></i>
                                </ngx-mat-popover>
                                </label>
                                <input onlyNumber formControlName="senha" id="senha" class="input" type="password" autocomplete="new-password" maxlength="10"/>
                            </div>
                            <div *ngIf="form.senha.invalid && (form.senha.dirty || form.senha.touched)"
                                class="text-danger">
                                <div *ngIf="form.senha.errors.required">
                                    Senha é obrigatória
                                </div>
                                <div *ngIf="form.senha.errors.minlength">
                                    Senha deve conter no mínimo 6 dígitos
                                </div>
                                <div *ngIf="form.senha.errors.maxlength">
                                    Senha deve conter no máximo 10 dígitos
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                        <div class="custom-pl-5">
                            <div class="input-container">
                                <input onlyNumber formControlName="senhaConfirmacao" id="senhaConfirmacao" class="input"
                                    type="password" autocomplete="new-password" maxlength="10"/>
                                <label class="label" for="senhaConfirmacao">Confirmar senha</label>
                            </div>
                            <div *ngIf="form.senhaConfirmacao.invalid && (form.senhaConfirmacao.dirty || form.senhaConfirmacao.touched)"
                                class="text-danger">
                                <div *ngIf="form.senhaConfirmacao.errors.required">
                                    Senha é obrigatória
                                </div>
                                <div *ngIf="form.senhaConfirmacao.errors.mustMatch">
                                    As senhas devem coincidir
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row button-container">
                    <div class="col-12 d-flex justify-content-end">
                        <button [disabled]="!gestorCadastroForm.valid" type="submit" class="button">
                            <span>Próximo</span>
                            <img src="./assets/icons/arrow-right.svg">
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>


<ng-template #popoverContent>
    <div class="titlePopover">Critérios de aceitação da senha</div>
    <div class="content">
      <ol>
          <li>A senha deve somente ter números</li>
          <li>A senha deve ter entre 6 a 10 dígitos</li>
          <li>A senha não pode ser parte do CPF, data de nascimento ou número de telefone</li>
          <li>Não é permitido dígitos iguais consecutivos. Exemplo: <span class="passExample">222222</span> ou <span class="passExample">222584</span></li>
          <li>Só é permitido até 2 dígitos sequencias consecutivos. Exemplo: <span class="passExample">238462</span></li>
      </ol>
    </div>
</ng-template>
